import { cn } from '@anytag/shared-utils';
import { SupportedSocialMediaType } from '@anytag/shared-types';
import { SocialIcon, SocialIconProps } from '../Icon';
import { ButtonLink, ButtonLinkProps } from './button-link';

export interface SocialButtonProps extends Omit<ButtonLinkProps, 'variant'> {
  hasIcon?: boolean;
  iconProps?: Omit<SocialIconProps, 'type'>;
  socialMedia: keyof typeof SupportedSocialMediaType;
}

export const SocialButton = ({
  title,
  hasIcon,
  loading,
  onClick,
  disabled,
  iconProps,
  className,
  socialMedia,
  ...restProps
}: SocialButtonProps) => {
  const backgroundClassName = (() => {
    switch (socialMedia) {
      case SupportedSocialMediaType.FACEBOOK:
      case SupportedSocialMediaType.FACEBOOK_PAGE:
        return 'bg-[#4460a0]';
      case SupportedSocialMediaType.INSTAGRAM:
      case SupportedSocialMediaType.INSTAGRAM_REEL:
      case SupportedSocialMediaType.INSTAGRAM_STORY:
      case SupportedSocialMediaType.INSTAGRAM_BUSINESS:
        return 'bg-[linear-gradient(to_right,#ae3bb0,#ff6641)]';
      case SupportedSocialMediaType.YOUTUBE:
        return 'bg-[#ce1312]';
      case SupportedSocialMediaType.TWITTER:
      case SupportedSocialMediaType.TIKTOK:
      case SupportedSocialMediaType.THREADS:
        return 'bg-[#000]';
      default:
        return 'bg-[#dee5ec]';
    }
  })();

  return (
    <ButtonLink
      {...restProps}
      variant="plain"
      size="xl"
      loading={loading}
      disabled={disabled}
      className={cn(
        'w-max border-none text-xs font-semibold text-white hover:text-white hover:opacity-80',
        {
          'pointer-events-none opacity-50': !!(typeof loading === 'boolean' ? loading : loading?.status) || disabled
        },
        backgroundClassName,
        className
      )}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault();
          onClick(e);
        }
      }}
      title={
        <div className={cn('flex items-center gap-2', { 'justify-start gap-2': hasIcon })}>
          {hasIcon ? <SocialIcon variant="white" type={socialMedia} {...iconProps} /> : null}
          {title}
        </div>
      }
    />
  );
};
